import { Box, Stack } from '@chakra-ui/react';

import RatingIcon from './RatingIcon';

const RatingButton = ({ onClick, rating, isSelected }) => (
  <Box
    as="button"
    aria-label={`Rate this video a ${rating}`}
    cursor="pointer"
    onClick={() => onClick(rating)}
  >
    <RatingIcon fill={isSelected ? 'gold' : 'gray'} h={2.5} w={2.5} />
  </Box>
);

const Rating = ({ rating, scale, onChange }) => {
  const handleClick = (newRating) => {
    // allow user to click first icon and set rating to zero if rating is already 1
    if (rating === 1 && newRating === 1) {
      onChange(0);
    } else {
      onChange(newRating);
    }
  };

  const buttons = [];
  for (let i = 1; i <= scale; i++) {
    buttons.push(
      <RatingButton
        key={i}
        rating={i}
        isSelected={i <= rating}
        onClick={handleClick}
      />,
    );
  }

  return (
    <Stack isInline justify="center">
      {buttons}
    </Stack>
  );
};

export default Rating;
